/* eslint-disable */
import _Vue from 'vue';
import { throttle } from './helpers';

declare global {
    interface HTMLElement {
        $destroy: Function;
    }
}

export default function(Vue: typeof _Vue) {
    Vue.directive('blur-loading', {
        bind(element: HTMLElement, binding: any) {
            element.style.transition = 'all 0.3s';
        },
        update(element: HTMLElement, binding: any) {
            if (binding.value) {
                element.style.filter = 'blur(2px)';
                element.style.opacity = '0.6';
            } else {
                element.style.filter = 'blur(0px)';
                element.style.opacity = '1';
            }
        },
        inserted(element: HTMLElement) {
            element.style.filter = 'blur(2px)';
            element.style.opacity = '0';
            setTimeout(() => {
                element.style.filter = 'blur(0px)';
                element.style.opacity = '1';
            }, 0);
        },
    });

    Vue.directive('focus', {
        inserted(el, binding: any) {
            if (binding.value) {
                el.focus();
            }
        },
    });

    Vue.directive('on-esc-keydown', {
        inserted(element: HTMLElement, binding: any) {
            if (binding.value) {
                const { callback } = binding.value;
                const keyboardListeners = (event: KeyboardEvent) => {
                    if (event.keyCode === 27) {
                        callback();
                    }
                };
                window.addEventListener('keydown', keyboardListeners);
                element.$destroy = () => {
                    window.removeEventListener('keydown', keyboardListeners);
                };
            }
        },
        unbind(element) {
            element.$destroy();
        },
    });

    Vue.directive('element-on-viewport', {
        inserted(element: HTMLElement, binding: any) {
            const { callback, delta = 0, condition = true } = binding.value;
            if (condition === false) return;
            const checkElementOnViewport = () => {
                const { top } = element.getBoundingClientRect();
                if (top <= (window.innerHeight || document.documentElement.clientHeight) + delta) {
                    callback(element);
                    element.$destroy();
                }
            };
            const throttleHandler = throttle(checkElementOnViewport, 300);
            window.addEventListener('scroll', throttleHandler);
            element.$destroy = () => {
                window.removeEventListener('scroll', throttleHandler);
            };
        },

        unbind(element, binding: any) {
            const { condition = true } = binding.value;
            if (condition === false) return;
            element.$destroy();
        },
    });

    Vue.directive('tooltip', {
        inserted(element: HTMLElement, binding) {
            if (binding.value) {
                const tooltip: HTMLElement = document.createElement('div');
                tooltip.className = 'fw-tooltip-wrapper';
                tooltip.textContent = binding.value;
                element.appendChild(tooltip);

                const showTooltip = () => {
                    if (element.style.position === 'static' || element.style.position === '') {
                        element.style.position = 'relative';
                    }
                    tooltip.classList.add('active');
                };
                const hideTooltip = () => {
                    tooltip.classList.remove('active');
                };

                element.addEventListener('mouseover', showTooltip);
                element.addEventListener('mouseleave', hideTooltip);
            }
        },
    });
}
